var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { styled } from '@mui/material';
import Debug from 'debug';
import React from 'react';
import { uniqueId } from '../utils';
var debug = Debug('Map:WaypointMarker');
var classes = {
    marker: 'waypoint-marker-marker',
    text: 'waypoint-marker-text',
};
var StyledG = styled('g')(function () {
    var _a;
    return (_a = {},
        _a["& ." + classes.marker] = {
            pointerEvents: 'none',
        },
        _a);
});
export var WaypointMarker = React.forwardRef(function (_a, ref) {
    var cx = _a.cx, cy = _a.cy, size = _a.size, otherProps = __rest(_a, ["cx", "cy", "size"]);
    debug('render');
    var waypointId = React.useMemo(uniqueId, []);
    return (React.createElement(StyledG, __assign({ ref: ref }, otherProps),
        React.createElement("defs", null,
            React.createElement("filter", { id: "waypoint-" + waypointId + "-shadow", x: "-20%", y: "-20%", width: "140%", height: "140%", filterUnits: "userSpaceOnUse" },
                React.createElement("feDropShadow", { dx: -0.05 * size, dy: -0.05 * size, stdDeviation: 0.15 * size, floodColor: "black" }))),
        React.createElement("rect", { className: classes.marker, x: cx - size / 2, y: cy - size / 2, width: size, height: size, fill: '#FFBF00', filter: "url(#waypoint-" + waypointId + "-shadow)" })));
});
